import { makeStyles } from '@material-ui/core/styles';

const usePageStyle = makeStyles(theme => ({
  page: {
    ...theme.page,
    background: theme.palette.primary.main,
    zIndex: 9999,
    paddingTop: '4em',
    [theme.breakpoints.down('sm')]: {
      padding: '1em',
      paddingTop: '10em',
    },
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - 200px)`,
      marginLeft: '200px',
    },
  },
  container: {
    //backgroundColor: 'yellow',
  },
}));

export default usePageStyle;
